module.exports = __webpack_public_path__ + "img/4-1.dcc729f3.jpg";